// ── Field — поле ввода с подписью ────────────────────────────────────────────
// Подпись связана с полем (нажатие по ней ставит курсор, диктор её читает),
// под полем — подсказка или ошибка. Высота 44 px; на телефоне шрифт 16 px —
// иначе iPhone увеличивает страницу при вводе.
//   <Field label="Email" type="email" value={v} onChange={(e)=>…} />
//   <Field label="Текст" multiline rows={6} … />
//   <Field label="Язык" select> <option…/> </Field>
//   <Field label="Начало дня" type="number" suffix="часов утра" … />

import { forwardRef, useId } from 'react';
import { SANS } from '../themes';
import { usePalette, usePhone } from './theme';

const Field = forwardRef(function Field({ label, hint, error, multiline = false, select = false, rows = 4, suffix, children, style, inputStyle, C: Cp, id: idProp, ...rest }, ref) {
  const C = usePalette(Cp);
  const phone = usePhone();
  const autoId = useId();
  const id = idProp || autoId;
  const base = {
    width: '100%', boxSizing: 'border-box', minHeight: 44, background: C.surface, color: C.text,
    border: `1.5px solid ${error ? C.danger : C.border}`, borderRadius: 10, padding: multiline ? '10px 13px' : '0 13px',
    fontSize: phone ? 16 : 14, fontFamily: SANS, outline: 'none', display: 'block', minWidth: 0, ...inputStyle,
  };
  const describedBy = error || hint ? `${id}-note` : undefined;
  return (
    <div style={{ marginBottom: 14, minWidth: 0, ...style }}>
      {label && <label htmlFor={id} style={{ display: 'block', fontSize: 11, fontWeight: 700, color: C.mid, marginBottom: 5, textTransform: 'uppercase',
        letterSpacing: '0.07em', overflowWrap: 'break-word' }}>{label}</label>}
      {select ? (
        <select ref={ref} id={id} aria-describedby={describedBy} aria-invalid={!!error || undefined} style={{ ...base, cursor: 'pointer' }} {...rest}>{children}</select>
      ) : multiline ? (
        <textarea ref={ref} id={id} rows={rows} aria-describedby={describedBy} aria-invalid={!!error || undefined} style={{ ...base, resize: 'vertical', lineHeight: 1.5 }} {...rest} />
      ) : suffix ? (
        // Поле и подпись после него («4 часов утра», «36500 дней»): поле узкое, подпись переносится.
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <input ref={ref} id={id} aria-describedby={describedBy} aria-invalid={!!error || undefined} style={{ ...base, width: 120, flex: '0 0 auto' }} {...rest} />
          <span style={{ fontSize: 13, color: C.mid, minWidth: 0 }}>{suffix}</span>
        </div>
      ) : (
        <input ref={ref} id={id} aria-describedby={describedBy} aria-invalid={!!error || undefined} style={base} {...rest} />
      )}
      {(error || hint) && (
        <div id={`${id}-note`} style={{ marginTop: 5, fontSize: 12.5, lineHeight: 1.4, color: error ? C.danger : C.faint, overflowWrap: 'break-word' }}>{error || hint}</div>
      )}
    </div>
  );
});

export default Field;
